.portfolioCard {
  /* Causes mobile to also have 50% width */
  /* width: 50%; */
  /* Have min-width with responsive media queries */
  min-width: 35vw;
  display: flex;
  flex-direction: column;
  background-color: var(--deal-card-bg-color);
  /* border: 1px solid var(--deal-border-color); */
  border-radius: 0.5rem;
  margin: 1.5rem 2rem;
  transition: all 0.3s ease;
}

.portfolioCard:hover {
  transform: var(--scale-card);
}

.debt {
  composes: debt from '../dealCard/DealCard.css';
}

.std {
  composes: std from '../dealCard/DealCard.css';
}

.logoWrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0.5rem 2rem 0.5rem 0;
}

.dealLogo {
  margin-top: -8px;
  width: '35%';
  height: '35%';
}

.portfolioAttributes {
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: repeat(2, auto);
  /* grid-column-gap: 10px; */
  /* flex-wrap: wrap; */
  align-items: center;
  justify-content: space-around;
  margin: 0 1rem;
}

.divider {
  height: 1px;
  border-top: 1px solid #dad9d9;
  margin: 1rem 35%;
}

.documents {
  display: flex;
}

.footer {
  margin: 0.5rem 1rem 1.5rem 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
}

.footerAttributes {
  display: flex;
  margin: 0.2rem 1rem;
}

.portfolioLogo {
  composes: dealLogo from '../dealCard/DealCard.css';
}

@media (max-width: 430px) {
  .portfolioAttributes {
    grid-template-rows: repeat(3, auto);
    grid-template-columns: repeat(2, auto);
  }
}

@media (min-width: 768.5px) and (max-width: 1349px) {
  .portfolioAttributes {
    grid-template-rows: repeat(3, auto);
    grid-template-columns: repeat(2, auto);
  }
}

@media (min-width: 768px) {
  .portfolioCard {
    max-width: 35vw;
  }
}

@media (max-width: 767.98px) {
  .portfolioCard {
    margin: 1.5rem 0.5rem;
    min-width: 80vw;
  }
}
